//External
import React from "react";
import { Modal } from "react-bootstrap";
import {
  get_cookie,
} from "utils";

/*******************
@Purpose : Used for break down modal
@Parameter : {breakDownObj,handleClose,isEmailMeShow,showModal}
@Author : INIC
******************/
function CommonInfoModal({ showModal, handleClose, infoDetails, title }) {
  const data = get_cookie("selectedCityName");

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/

  return (
    <Modal
      show={showModal}
      // centered
      // aria-labelledby="contained-modal-title-vcenter"
      className="breakdown-modal pl-0"
      onHide={handleClose}
    >
      <Modal.Header closeButton className="text-left">
        <h3 className="modal-title">{title}</h3>
      </Modal.Header>
      <Modal.Body className="px-0">
        <div className="list-unstyled mb-0 rental-list">
          <div className="common-seprarte mb-3">{infoDetails}</div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CommonInfoModal;
